import React, { useContext } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ServiceOrderContext, UserContext } from '../../../../App';
import Navbar from '../../Navbar/Navbar';

const ServiceOrder = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    const history = useHistory()
    const [serviceOrder, setServiceOrder] = useContext(ServiceOrderContext)
    const { id } = useParams();
    useEffect(() => {
        fetch('https://assignment-11-samiun.herokuapp.com/service/' + id)
        .then(res => res.json())
        .then(data => setServiceOrder(data))
    }, [id])

    const {title, description, img, price,} = serviceOrder
    const {email, displayName} = loggedInUser
    const handleClick = () => {
        history.push('/order')
    }
    return (
        <div>
           <Navbar/>
            <div className="row mt-5">
                <div className="col-md-4 mt-5 offset-md-2">
                    <h2 className="text-color"><b>{title}</b></h2>
                    <p className="text-secondary">{description}</p>
                    <ul>
                        <li>Filet mignon tri-tip sausage</li>
                        <li>Salami ground round strip</li>
                        <li>Steak rump pork ribeye</li>
                        <li>Burgdoggen tail landjaeger</li>
                    </ul>
                    <h4>Price: ${price}</h4>
                    <button className="btn-style mt-3" style={{width: '100px'}} onClick={handleClick}>Order</button>
                    
                </div> 
            </div>
        </div>
    );
};

export default ServiceOrder;